/**
 * Centralized upload limits for the admin/partner frontend.
 *
 * Single source of truth — every component that validates an image upload
 * should import from here. The value can be overridden at build time via the
 * `REACT_APP_MAX_UPLOAD_MB` environment variable. Default: 20 MB.
 *
 * Keep this in sync with backend's `MAX_IMAGE_UPLOAD_MB` setting (config.py).
 */

const parsed = parseInt(process.env.REACT_APP_MAX_UPLOAD_MB || '', 10);
export const MAX_UPLOAD_MB = Number.isFinite(parsed) && parsed > 0 ? parsed : 20;
export const MAX_UPLOAD_BYTES = MAX_UPLOAD_MB * 1024 * 1024;
